import { Navigate } from "react-router-dom";

/** The « Signaux presse » folder now lives on its own page, /actualites (menu « Actualités »). */
export default function PressSignalsFeed() {
    return <Navigate to="/actualites" replace />;
}
